
<template>
  <div v-wechat-title="myTitle">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="inputRect">
      <van-field
        v-model="formData.lastName"
        required
        clearable
        label="姓"
        placeholder="例如zhang"
        :readonly="isHaveCerificate"
      />
      <van-field
        v-model="formData.firstName"
        required
        clearable
        label="名"
        placeholder="例如san feng"
        :readonly="isHaveCerificate"
      />
      <van-field
        v-model="formData.birthday"
        required
        clearable
        label="生日"
        placeholder="请输入生日"
        readonly
        @click="onSelectBirthday"
      />
      <van-field
        v-model="formData.email"
        clearable
        label="邮箱"
        placeholder="请输入电子邮箱"
      />
      <div class="buttonRect">
        <van-button type="primary" size="large" :disabled="buttonDisable" :loading="buttonLoading" :color="GetColorMain()" @click="onSubject">{{ isHaveCerificate?"保存邮箱":"保存" }}</van-button>
      </div>
    </div>

    <div v-if="isHaveCerificate" class="notice">您的信息已经确认，不能修改姓名、生日。如需修改请联系客服！</div>
    <dateSelect v-model="showBirthday" :default-date="baseDate" @onChange="onBirthdayChange" />
    <followWx v-model="showFollow" @finish="buttonDisable=false" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Toast, Dialog } from 'vant'
import { formatDate, MyNotify, checkUserLastName } from '@/utils/base'
import TopBar from '@/components/TopBar'
import dateSelect from '@/components/dateSelect'
import followWx from '@/components/followWx'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { CheckSystemType } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    TopBar,
    dateSelect,
    followWx
  },
  data() {
    return {
      myTitle: '',
      title: '修改姓名生日',
      backurl: '/my/index',
      buttonLoading: false,
      showBirthday: false,
      baseDate: undefined,
      isHaveCerificate: true,
      isEmailCheck: false,
      buttonDisable: true,
      showFollow: false,
      formData: {
        lastName: '',
        firstName: '',
        birthday: '',
        email: ''
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  created() {
    this.init()
    this.myTitle = GetSysTitle()
  },
  methods: {
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onSelectBirthday() {
      if (this.isHaveCerificate) {
        return
      }
      this.showBirthday = true
    },
    onSubject() {
      if (!this.isHaveCerificate) {
        if (this.formData.lastName.length < 1) {
          MyNotify('error', '请输入英文（拼音）姓,例如zhang')
          return
        }
        if (this.formData.firstName.length < 1) {
          MyNotify('error', '请输入英文（拼音）名,例如san feng')
          return
        }
        if (this.formData.birthday.length < 1) {
          MyNotify('error', '请选择生日')
          return
        }
        let EmailStr = ''
        if (this.formData.email.length > 0) {
          EmailStr = '\n邮箱:' + this.formData.email
        }
        checkUserLastName(this.formData.firstName, () => {
          Dialog.confirm({
            title: '核对信息',
            message: '请核对您的\n英文姓:' + this.formData.lastName + '\n英文名:' + this.formData.firstName + '\n生日:' + this.formData.birthday + EmailStr + '\n是否正确,一旦提交无法修改'
          }).then(() => {
            this.onPostData()
          })
        })
      } else {
        this.onPostData()
      }
    },
    init() {
      request({
        url: '/user/getUserNameBirthday',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        setTimeout(() => {
          this.showFollow = true
        }, 10)
        this.isHaveCerificate = response.data.isHaveCerificate
        this.formData.lastName = response.data.lastName ? response.data.lastName : ''
        this.formData.firstName = response.data.firstName ? response.data.firstName : ''
        this.formData.email = response.data.email ? response.data.email : ''
        this.isEmailCheck = response.data.isEmailCheck
        if (response.data.birthday) {
          this.baseDate = response.data.birthday
          this.formData.birthday = formatDate(response.data.birthday, 'yyyy/MM/dd')
        }
      })
    },
    onBirthdayChange(date) {
      this.formData.birthday = date
    },
    onPostData() {
      this.buttonLoading = true
      request({
        url: '/user/updateUserNameBirthday',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (!response.data) {
          Toast.success('个人资料修改成功')
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push('/user/index')
        } else {
          Dialog.alert({
            title: '个人资料修改成功',
            message: '个人资料修改成功,但因为以下原因，尚未能进行查询潜水员资质，请稍后再试或者联系客服人员:' + response.data
          }).then(() => {
            window.history.length > 1
              ? this.$router.go(-1)
              : this.$router.push('/user/index')
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.notice{
  color: #999;
  text-align: center;
  font-size: 0.7em;
  margin-top: 0.3em;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
</style>
